import { useState } from 'react';
import type { PopoverProps } from '@mui/material';
import { Typography } from '@mui/material';

import {
  BodyContainer,
  BodyItemContainer,
  CheckButton,
  CheckButtonContainer,
  CheckButtonIconContainer,
  CheckInstructionButton,
  Container,
  StyledPopover,
  TopContainer,
  TopLeftContainer,
  WrapperContainer,
} from './styled';
import GradientButton from '../GradientButton';

import { ReactComponent as CheckIcon } from 'src/assets/svg/Check.svg';

type DisclaimerPopoverProps = Omit<PopoverProps, 'children'>;

export default function DisclaimerPopover({ onClose, ...remainder }: DisclaimerPopoverProps) {
  const [isCheckedInstruction, setIsCheckedInstruction] = useState(false);

  return (
    <WrapperContainer data-is-open={remainder.open}>
      <StyledPopover {...remainder}>
        <Container>
          <TopContainer>
            <TopLeftContainer>
              <Typography variant="h2">Disclaimer</Typography>
            </TopLeftContainer>
          </TopContainer>
          <BodyContainer>
            <BodyItemContainer>
              {
                'DISCLAIMER: ALL THE FUNCTIONS AND CONTENT BELOW ARE NOT PROVIDED TO PERSONS WHO ARE CURRENTLY OR ORDINARILY LOCATED OR RESIDENT IN THE UNITED STATES OR ITS TERRITORIES, REGARDLESS OF IP ADDRESS. NONE OF TOKEN HAVE BEEN OR WILL BE REGISTERED UNDER THE U.S. SECURITIES ACT OF 1933, AS AMENDED, OR WITH ANY SECURITIES REGULATORY AUTHORITY OF ANY STATE OR OTHER JURISDICTION OF THE U.S. TOKENS MAY NOT BE OFFERED, SOLD, OR DELIVERED WITHIN THE U.S. TO, OR FOR THE ACCOUNT OR BENEFIT OF, RESTRICTED PERSONS AS PROVIDED ABOVE. NO OFFERS, SALES, RESALES, OR DELIVERIES OF ANY OF OUR TOKEN PRODUCTS MAY BE MADE IN OR FROM ANY JURISDICTION (INCLUDING THE U.S.), EXCEPT IN CIRCUMSTANCES THAT WILL RESULT IN COMPLIANCE WITH ANY APPLICABLE LAWS AND REGULATIONS. PERSONS WHO OBTAIN OUR TOKEN PRODUCTS ARE REQUIRED TO INFORM THEMSELVES ABOUT AND ADHERE TO ANY SUCH RESTRICTIONS. THE TERM "RESTRICTED PERSON" INCLUDES, BUT IS NOT LIMITED TO, ANY NATURAL PERSON RESIDING IN, OR ANY FIRM, COMPANY, PARTNERSHIP, TRUST, CORPORATION, ENTITY, GOVERNMENT, STATE OR AGENCY OF A STATE, OR ANY OTHER INCORPORATED OR UNINCORPORATED BODY OR ASSOCIATION, ASSOCIATION OR PARTNERSHIP (WHETHER OR NOT HAVING SEPARATE LEGAL PERSONALITY) THAT IS ESTABLISHED AND/OR LAWFULLY EXISTING UNDER THE LAWS OF, A JURISDICTION IN WHICH SUCH OFFER, SALE, AND/OR PURCHASE OF ANY OF OUR TOKEN PRODUCTS IS UNLAWFUL, PROHIBITED, OR UNAUTHORIZED). UTILIZING A VIRTUAL PRIVATE NETWORK OR OTHER METHOD TO CONCEAL A USER\'S UNITED STATES RESIDENCE IS ALSO STRICTLY PROHIBITED.'
              }
              <CheckInstructionButton
                onClick={() => {
                  setIsCheckedInstruction(!isCheckedInstruction);
                }}
              >
                <CheckButtonContainer>
                  <CheckButton>
                    {isCheckedInstruction ? (
                      <CheckButtonIconContainer>
                        <CheckIcon />
                      </CheckButtonIconContainer>
                    ) : null}
                  </CheckButton>
                </CheckButtonContainer>
                <Typography variant="h7">I have read the disclaimer and agree to the text</Typography>
              </CheckInstructionButton>
            </BodyItemContainer>
          </BodyContainer>

          <GradientButton
            disabled={!isCheckedInstruction}
            onClick={() => {
              onClose?.({}, 'backdropClick');
            }}
          >
            <Typography variant="h4">CONFIRM</Typography>
          </GradientButton>
        </Container>
      </StyledPopover>
    </WrapperContainer>
  );
}
